<div class="d-flex flex-wrap">
    @for (name of filesUploaded; let nameIndex = $index; track nameIndex) {
        <div class="d-flex mx-3">
            {{ getFileName(name) }}
            @if (!removing) {
                <mat-icon (click)="removeFiles(name, nameIndex)">close</mat-icon>
            }
            @if (removing) {
                <mat-spinner diameter="18" class="ms-2" />
            }
        </div>
    }
</div>
